import { c, classy, m } from '@onfido/castor';
import React from 'react';
import { withRef } from '../../utils';
/**
 * Intended to be used with field components, incl. `FieldLabel` itself.
 */
export const HelperText = withRef(function HelperText({ disabled, className, ...restProps }, ref) {
    return (React.createElement("span", { ...restProps, ref: ref, className: classy(c('helper-text'), m({ disabled }), className) }));
});
//# sourceMappingURL=helper-text.js.map